import { IApiProfileBase } from './IApiProfileBase';

export enum ApiRoutingExecutionType {
  BOOK_A = 'BOOK_A',
  BOOK_B = 'BOOK_B',
  REJECT = 'REJECT',
}

export interface IApiRoutingProfile extends IApiProfileBase {
  executionType: ApiRoutingExecutionType;
  minBBookDelay?: number;
  maxBBookDelay?: number;
}

export interface IApiRoutingProfileUpdate {
  id?: IApiRoutingProfile['id'];
  name: string;
  executionType: ApiRoutingExecutionType;
  minBBookDelay?: number;
  maxBBookDelay?: number;
}

export interface IApiRoutingProfileDefault {
  executionType: ApiRoutingExecutionType;
  minBBookDelay: number;
  maxBBookDelay: number;
}
